import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { UserService } from 'src/app/shared/services/node-api/user.service';
// Declare the external function
declare let loadPlacement: any;

@Component({
  selector: 'app-feeds-probo-card',
  templateUrl: './feeds-probo-card.component.html',
  styleUrls: ['./feeds-probo-card.component.scss']
})
export class FeedsProboCardComponent implements OnInit {
  @Input() probo: any;
  authToken: string;
  proboPostId: string;
  isUserLoggedIn: string;
  userId:string;
  probo_token:string;


  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    private userService : UserService
  ) {
    this.authToken = this.localStorageService.getItem('token');
    this.userId = this.localStorageService.getItem('userId');
    this.isUserLoggedIn = this.localStorageService.getItem('isUserLoggedIn');
    this.probo_token = this.localStorageService.getItem('probo_token');
  }

  ngOnInit(): void {
    if (this.probo) {
      this.loadProbo();
    } else {
      console.error('Probo data is not available');
    }
  }

  loadProbo() {
    this.loadBoxScript().then(() => {
      this.loadBoxWidget();
    }).catch(error => {
      console.error('Failed to load b.ox script:', error);
    });
  }

  // Function to dynamically load the b.ox script
  loadBoxScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = this.probo.url;
      script.onload = () => resolve();
      script.onerror = () => reject('Error loading script');
      document.body.appendChild(script);
    });
  }

  // Function to load the b.ox widget after the script has been loaded
  loadBoxWidget(): void {
    if (typeof loadPlacement === 'function') {
      loadPlacement({
        placementId: this.probo.questionId, // Provide the placement ID here
        keywords: this.probo.categories,
        accessId: this.probo.accessId,
        auth: {
          token: this.authToken
        },
        events: {
          login: 'userLoggedIn',
          logout: 'userLoggedOut'
        },
      });
    } else {
      console.error('loadPlacement function is not available.');
    }
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent): void {
    // Verify the origin of the message
    // console.log("origin", event.origin);
    // if (event.origin !== 'https://dev-widget.bharatox.com') {
    //   console.warn('Origin mismatch. Message ignored.');
    //   return;
    // }
    const receivedData = event.data;
    // console.log("Receive Data", receivedData)
    if (receivedData.type === 'height_change' && receivedData.height) {
      const parentDiv = document.getElementById(this.probo.questionId);
      if (parentDiv) {
        parentDiv.style.height = receivedData.height + 'px';
      }
    }
    if(receivedData.type === 'open_login_page' || receivedData.type === 'login_successfully'){
      if (this.authToken && !this.isUserLoggedIn) {
        // Create an object to hold the authentication data (e.g., a token)
        const eventData = {
          auth: {
            token: this.authToken // Placeholder for the authentication token to be inserted here
          },
        };
        /*
        Create a custom event named 'userLoggedIn'.
        This event is used to notify the iframe after the user has logged in successfully.
        */
        const customEvent = new CustomEvent('userLoggedIn', {
          detail: eventData // Attach the authentication data to the event
        });

        // Dispatch the custom event to the iframe
        window.dispatchEvent(customEvent);
        // console.log('dispatchEvent', customEvent);
      }


      // console.log('received Event', receivedData.type);
      // console.log('received Event Object', receivedData);

      if (receivedData.type === 'open_login_page') {
        // Save redirection in localStorage
        this.localStorageService.setItem('redirect_url', '/feed/bharat/' + this.probo._id);
        // Redirect user to login page
        this.router.navigate(['/user/login']);
      } else if (receivedData.type === 'login_successfully') {
        // Handle successful login
        this.localStorageService.setItem('probo_token', receivedData.token);
        this.localStorageService.setItem('isUserLoggedIn', true);
        this.localStorageService.setItem('probo_source_name', receivedData.sourceName);
        this.saveProboData(receivedData);
      }
    }
  }

  saveProboData(data){
    let document ={
      id: this.userId,
      probo_token: data.token,
      probo_source_name: data.sourceName,
    }
    this.userService
    .updateUserProfile(document)
    .then((data: any) => {
      this.probo = data;
    })
    .catch((err: any) => {
      console.log(err);
    });
  }

}
